import { useTheme } from '@material-ui/core';
import { renderChildren } from '@superdispatch/ui';
export function LightDark(_ref) {
  var {
    light,
    dark
  } = _ref;
  var theme = useTheme();
  var isDarkMode = theme.palette.type === 'dark';
  var mode = isDarkMode ? dark : light;
  return renderChildren(mode);
}